import sidebarBgImage from 'assets/img/sidebar/network-2.jpg';
import SourceLink from 'views/components/SourceLink';
import React, { Fragment } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { Nav, Navbar, NavItem, NavLink as BSNavLink, Collapse } from 'reactstrap';
import bn from 'utils/bemnames';
import {
  navGeneralItems,
  navGeneralTaxItems,
  navGeneralNotificationItems,
  navGeneralNotificationV2Items,
} from '../../../configs/navigationItems';
import { getStoredObject } from '../../../helpers/storageHelper';
import { StorageKeys } from '../../../constants/storageKeys';
import { connect } from 'react-redux';
import cx from 'classnames';
import { MdKeyboardArrowDown, MdSettings } from 'react-icons/md';
import { hasPermission } from 'services/permissionService';
import { clearAllFilters } from 'helpers/filterHelper';

const sidebarBackground = {
  backgroundImage: `url("${sidebarBgImage}")`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};

const bem = bn.create('sidebar');

class GeneralSidebar extends React.Component {
  state = {
    userRoles: [],
    currentLink: '',
    isOpenTaxSetup: false,
    isOpenNotification: false,
    isOpenNotificationV1: false,
    isOpenNotificationV2: false,
  };

  getGeneralPath = () => {
    const hashPath = window.location.hash.replace(/^#/, '');
    const prefix = '/general';
    const path = hashPath.startsWith(prefix)
      ? hashPath.slice(prefix.length)
      : hashPath;
    return path.split('?')[0];
  };

  matchesNav = (items, path) =>
    items.find(
      i =>
        i.to == path ||
        i.childrenRoutes?.find(r => path === r || path.startsWith(`${r}/`) || path.startsWith(`${r}?`)),
    );

  syncOpenStateFromPath = () => {
    const path = this.getGeneralPath();
    const nextState = { currentLink: path };

    if (this.matchesNav(navGeneralTaxItems, path)) {
      nextState.isOpenTaxSetup = true;
    }
    if (this.matchesNav(navGeneralNotificationItems, path)) {
      nextState.isOpenNotification = true;
      nextState.isOpenNotificationV1 = true;
    }
    if (this.matchesNav(navGeneralNotificationV2Items, path)) {
      nextState.isOpenNotification = true;
      nextState.isOpenNotificationV2 = true;
    }

    this.setState(nextState);
  };

  componentDidMount() {
    this.setState({ userRoles: this.getRoleNames() });
    this.syncOpenStateFromPath();
    window.addEventListener('hashchange', this.syncOpenStateFromPath);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.syncOpenStateFromPath);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.syncOpenStateFromPath();
    }
  }

  showGroup = (navGroupItems, userRoles) => {
    return navGroupItems.some(item => this.showNavItem(item.roles, userRoles, item.resource, item.action));
  };

  showNavItem = (rolesAllow, userRoles, resource, action) => {
    if (!rolesAllow) {
      const { profile } = this.props;

      if (profile && profile.isDmsAdmin) return true;

      return hasPermission(resource, action, profile.permissions);
    }

    if (rolesAllow.length === 0) {
      return false;
    }

    return userRoles.some(r => rolesAllow.includes(r?.roleName));
    // return userRoles.some(r => rolesAllow.includes(r));
  };

  getRoleNames = () => {
    let { profile } = this.props;
    if (!profile || !profile.userRoleEntities) {
      profile = getStoredObject(StorageKeys.Profile);
    }
    if (profile && profile.userRoleEntities) {
      return profile.userRoleEntities;
    } else {
      return [];
    }
  };

  handleClick = name => () => {
    this.setState(prevState => {
      const isOpen = prevState[`isOpen${name}`];

      return {
        [`isOpen${name}`]: !isOpen,
      };
    });
  };

  renderMenuItem = ({ to, name, exact, Icon, roles, childrenRoutes, resource, action }, index, className) => {
    const { userRoles } = this.state;
    const path = this.getGeneralPath();

    // Active only from current URL — do not keep previous sidebar click sticky.
    const isCurrentLink =
      path === to ||
      !!(childrenRoutes && childrenRoutes.find(r => path === r || path.startsWith(`${r}/`) || path.startsWith(`${r}?`)));

    return (
      this.showNavItem(roles, userRoles, resource, action) && (
        <NavItem key={index} className={cx({ 'active-item-tab': isCurrentLink }, className)}>
          <BSNavLink
            id={`navItem-${name}-${index}`}
            tag={NavLink}
            to={`/general${to}`}
            className={isCurrentLink ? 'active' : ''}
            // Default exact to avoid /notification-list matching /notification-list-v2
            exact={exact !== false}
            onClick={() => {
              clearAllFilters();
              this.setState({ currentLink: to });
            }}
          >
            <Icon className={bem.e('nav-item-icon')} />
            <span className="">{name}</span>
          </BSNavLink>
        </NavItem>
      )
    );
  };

  render() {
    const { userRoles } = this.state;

    return (
      <aside className={bem.b()} data-image={sidebarBgImage}>
        <div className={bem.e('background')} style={sidebarBackground} />
        <div className={bem.e('content')}>
          <Navbar>
            <SourceLink className="navbar-brand d-flex">
              <span className="text-white">DMS</span>
            </SourceLink>
          </Navbar>
          <Nav vertical>
            {this.showGroup(navGeneralItems, userRoles) &&
              navGeneralItems.map((item, index) => this.renderMenuItem(item, index))}

            {(this.showGroup(navGeneralNotificationItems, userRoles) ||
              this.showGroup(navGeneralNotificationV2Items, userRoles)) && (
              <Fragment>
                <NavItem className={bem.e('nav-item')} onClick={this.handleClick('Notification')}>
                  <BSNavLink className={bem.e('nav-item-collapse')}>
                    <div className="d-flex">
                      <MdSettings className={bem.e('nav-item-icon')} />
                      <span className=" align-self-start">Notification</span>
                    </div>
                    <MdKeyboardArrowDown
                      className={bem.e('nav-item-icon')}
                      style={{
                        padding: 0,
                        transform: this.state.isOpenNotification ? 'rotate(0deg)' : 'rotate(-90deg)',
                        transitionDuration: '0.3s',
                        transitionProperty: 'transform',
                      }}
                    />
                  </BSNavLink>
                </NavItem>
                <Collapse isOpen={this.state.isOpenNotification}>
                  {this.showGroup(navGeneralNotificationItems, userRoles) && (
                    <Fragment>
                      <NavItem
                        className={cx(bem.e('nav-item'), 'pl-2')}
                        onClick={this.handleClick('NotificationV1')}
                      >
                        <BSNavLink className={bem.e('nav-item-collapse')}>
                          <div className="d-flex">
                            <MdSettings className={bem.e('nav-item-icon')} />
                            <span className=" align-self-start">V1</span>
                          </div>
                          <MdKeyboardArrowDown
                            className={bem.e('nav-item-icon')}
                            style={{
                              padding: 0,
                              transform: this.state.isOpenNotificationV1 ? 'rotate(0deg)' : 'rotate(-90deg)',
                              transitionDuration: '0.3s',
                              transitionProperty: 'transform',
                            }}
                          />
                        </BSNavLink>
                      </NavItem>
                      <Collapse isOpen={this.state.isOpenNotificationV1}>
                        {navGeneralNotificationItems.map((item, index) =>
                          this.renderMenuItem(item, index, 'pl-3'),
                        )}
                      </Collapse>
                    </Fragment>
                  )}
                  {this.showGroup(navGeneralNotificationV2Items, userRoles) && (
                    <Fragment>
                      <NavItem
                        className={cx(bem.e('nav-item'), 'pl-2')}
                        onClick={this.handleClick('NotificationV2')}
                      >
                        <BSNavLink className={bem.e('nav-item-collapse')}>
                          <div className="d-flex">
                            <MdSettings className={bem.e('nav-item-icon')} />
                            <span className=" align-self-start">V2</span>
                          </div>
                          <MdKeyboardArrowDown
                            className={bem.e('nav-item-icon')}
                            style={{
                              padding: 0,
                              transform: this.state.isOpenNotificationV2 ? 'rotate(0deg)' : 'rotate(-90deg)',
                              transitionDuration: '0.3s',
                              transitionProperty: 'transform',
                            }}
                          />
                        </BSNavLink>
                      </NavItem>
                      <Collapse isOpen={this.state.isOpenNotificationV2}>
                        {navGeneralNotificationV2Items.map((item, index) =>
                          this.renderMenuItem(item, index, 'pl-3'),
                        )}
                      </Collapse>
                    </Fragment>
                  )}
                </Collapse>
              </Fragment>
            )}


            {this.showGroup(navGeneralTaxItems, userRoles) && (
              <Fragment>
                <NavItem className={bem.e('nav-item')} onClick={this.handleClick('TaxSetup')}>
                  <BSNavLink className={bem.e('nav-item-collapse')}>
                    <div className="d-flex">
                      <MdSettings className={bem.e('nav-item-icon')} />
                      <span className=" align-self-start">Tax</span>
                    </div>
                    <MdKeyboardArrowDown
                      className={bem.e('nav-item-icon')}
                      style={{
                        padding: 0,
                        transform: this.state.isOpenTaxSetup ? 'rotate(0deg)' : 'rotate(-90deg)',
                        transitionDuration: '0.3s',
                        transitionProperty: 'transform',
                      }}
                    />
                  </BSNavLink>
                </NavItem>
                <Collapse isOpen={this.state.isOpenTaxSetup}>
                  {navGeneralTaxItems.map((item, index) => this.renderMenuItem(item, index, 'pl-2'))}
                </Collapse>
              </Fragment>
            )}
          </Nav>
        </div>
      </aside>
    );
  }
}

const mapStateToProps = ({ account }) => ({
  profile: account.profile,
});

export default connect(mapStateToProps, null)(withRouter(GeneralSidebar));
